import * as React from "react";
import { Icon } from "../../icon/icon/icon.mjs";
import { ListContext } from "../list/list.mjs";
const ListItem = (props) => {
  var _a;
  const context = React.useContext(ListContext);
  const iconClassName = (_a = props.iconClassName) != null ? _a : context.iconClassName;
  const icon = props.icon || context.icon;
  const direction = context.direction;
  const BEM = () => {
    const classArray = ["list__item"];
    if (props.className) {
      classArray.push(props.className);
    }
    return classArray.join(" ");
  };
  const iconBEM = (icon2) => {
    const classArray = ["list__icon"];
    if (icon2 === "#check") {
      classArray.push("list__icon--check");
    }
    if (iconClassName) {
      classArray.push(iconClassName);
    }
    return classArray.join(" ");
  };
  const getIcon = (icon2) => {
    return /* @__PURE__ */ React.createElement(Icon, { modifiers: icon2, size: context.iconSize, className: iconBEM(icon2), "aria-hidden": true });
  };
  return /* @__PURE__ */ React.createElement("li", { className: BEM() }, /* @__PURE__ */ React.createElement("div", { className: "list__item-inner" }, icon && !direction && getIcon(icon), /* @__PURE__ */ React.createElement("div", { className: "list__content" }, props.children)));
};
export {
  ListItem
};
